import React from 'react';
import LegalPage from '@/components/LegalPage';
import { Seo, breadcrumbSchema, webPageSchema } from '../components/Seo';

const Refund = () => (
  <>
    <Seo
      title="Refund Policy · AdAura Awards 2026"
      description="Refund policy for AdAura Awards nominations. When and how refunds may be requested from Marketing Mind."
      path="/refund"
      jsonLd={[
        webPageSchema({ path: '/refund', name: 'Refund', description: 'Refund policy for AdAura Awards nominations.' }),
        breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Refund', path: '/refund' }]),
      ]}
    />
  <LegalPage
    kicker="Legal"
    title="Refund &amp; Cancellation Policy"
    lastUpdated="26 February 2026"
  >
    <p>
      We want you to feel confident submitting your work to The AdAura Awards
      2026. This policy explains when an entry fee is refundable, when it is
      not, and how to request a refund.
    </p>

    <h2>1. Withdrawals before the entry deadline</h2>
    <p>
      You may withdraw a nomination and request a full refund at any time
      <strong> before the close of the entry window</strong> (currently
      <strong> 6 September 2026, 23:59 IST</strong>) by writing to
      <a href="mailto:atuldwivedi@marketingmind.in"> atuldwivedi@marketingmind.in </a>
      from the email registered against the entry, with the entry number and a
      brief reason. Refunds are processed to the original payment method within
      <strong> 7–10 business days</strong> via Razorpay.
    </p>

    <h2>2. After the entry deadline</h2>
    <p>
      Once the entry window closes, jury assignment and judging logistics
      begin. Entry fees become <strong>non-refundable</strong> at that point,
      except in the cases listed below.
    </p>

    <h2>3. Exceptions — full refund</h2>
    <ul>
      <li><strong>Duplicate payment</strong> — if our records show two charges for the same nomination, the duplicate is refunded automatically within 5 business days, no request needed.</li>
      <li><strong>Category cancelled by Marketing Mind</strong> — if we discontinue a category after you have entered, you may either transfer the nomination to another category at no charge, or take a full refund.</li>
      <li><strong>Technical fault</strong> — if a confirmed platform error prevents your submission from being assessed, we refund in full.</li>
    </ul>

    <h2>4. Exceptions — partial refund</h2>
    <ul>
      <li>Disqualification for breach of these Terms (see <a href="/terms">Terms &amp; Conditions §7</a>) — <strong>no refund</strong>. The fee has covered the cost of triage and review.</li>
      <li>Self-withdrawal after the deadline but before scoring begins — eligible for a <strong>50% refund</strong>, at our discretion.</li>
      <li>Self-withdrawal after scoring has begun — <strong>no refund</strong>.</li>
    </ul>

    <h2>5. Award outcomes</h2>
    <p>
      Receiving a shortlist, finalist, or any award placement does not affect
      the refund window. Likewise, not winning is not grounds for a refund.
    </p>

    <h2>6. How refunds are processed</h2>
    <ul>
      <li>All refunds are credited back to the original Razorpay payment method (card, UPI, net-banking, wallet).</li>
      <li>Indian payment networks typically reflect the refund within 5–7 business days; international cards may take up to 14.</li>
      <li>Where the original method is no longer available (closed account, expired card), we will refund by NEFT to a verified bank account on submission of a cancelled cheque copy.</li>
    </ul>

    <h2>7. GST on refunds</h2>
    <p>
      Refunds include the 18% GST component originally collected. A credit note
      is issued and a revised tax invoice (where applicable) is emailed.
    </p>

    <h2>8. How to request</h2>
    <p>
      Email <a href="mailto:atuldwivedi@marketingmind.in">atuldwivedi@marketingmind.in</a> from the address used at registration, with:
    </p>
    <ul>
      <li>The entry number(s) and category</li>
      <li>The Razorpay payment ID</li>
      <li>A brief reason for the refund</li>
    </ul>
    <p>
      You’ll receive an acknowledgement within two business days. Refund status
      can be tracked in your nominator portal under <strong>My Entries</strong>.
    </p>
  </LegalPage>
  </>
);

export default Refund;
